import { LicenseType, PaginationSort } from '../gql/graphql';
import { getPaginatedNodes, toPagination } from './utils';

import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_BROKERAGE_LICENSE = graphql(`
  query getBrokerageLicenses(
    $pagination: PaginationRequest
    $filters: EntityFilterInput!
    $sort: PaginationSort
    $licenseFilter: LicenseFilterInput
  ) {
    entities(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        cursor
        node {
          uuid
          referenceId
          type
          status
          fein
          agency
          brokerCommission
          digitalCommission
          retailCommission
          insurer
          createdAt
          licenses(filters: $licenseFilter) {
            edges {
              cursor
              node {
                uuid
                licenseNumber
                expirationDate
                licenseType
                source
                forState
                region {
                  name
                  iso2Code
                  uuid
                }
              }
            }
          }
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export function useGetBrokerageLicense({
  pageNumber = 0,
  pageSize = 15,
  uuid,
  isParent = undefined,
  enabled = true,
  sort,
  regionUuid,
  licenseType,
}: {
  pageNumber?: number;
  pageSize?: number;
  uuid?: string;
  isParent?: boolean;
  enabled?: boolean;
  sort?: PaginationSort;
  regionUuid: string;
  licenseType?: LicenseType;
}) {
  // const variables = {
  //   pagination: toPagination(pageNumber, pageSize),
  //   filters: { agency: true, entityUuid: uuid },
  //   licenseFilter: {
  //     regionUuid: regionUuid,
  //     licenseType: licenseType,
  //   },
  //   sort,
  // };

  const { loading, error, data } = useQuery(GET_BROKERAGE_LICENSE, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      filters: { agency: true, entityUuid: uuid },
      licenseFilter: {
        regionUuid: regionUuid,
        licenseType: licenseType,
      },
      sort,
    },
    fetchPolicy: 'no-cache',
    skip: !enabled,
  });

  const brokerageLicense = useMemo(() => {
    if (!data || !data.entities || !data.entities.edges) return [];

    const licenseList: {
      label: string | null | undefined;
      value: string | null | undefined;
    }[] = [];

    getPaginatedNodes(data.entities).forEach((edge) => {
      const licenses = getPaginatedNodes(edge.licenses);

      licenses.forEach((license) => {
        licenseList.push({
          value: license.uuid,
          label: license.licenseNumber,
        });
      });
    });
    return licenseList;
  }, [data]);

  return {
    error,
    loading,
    data,
    brokerageLicense,
  };
}
